import { GridEditor } from "../features/planBTV2/GridEditor";
import DashboardListPage from "../pages/Dashboard/DasboardListPage/DashboardListPage";
import DashboardHubPage from "../pages/Dashboards/DashboardHubPage/DashboardHubPage";
import DashboardDefaultPage from "../pages/Dashboards/DashboardDefaultPage/DashboardDefaultPage";
import { ExtractPage } from "../features/extract";
import HomePage from "../pages/HomePage/HomePage";
import CreateMinigridPage from "../pages/Minigrid/CreateMinigridPage/CreateMinigridPage";
import MinigridListPage from "../pages/Minigrid/MinigridListPage/MinigridListPage";
import SingleMinigridPage from "../pages/Minigrid/SingleMinigrid/SingleMinigridPage/SingleMinigridPage";
import MinigridLiveEnergyDashboardPage from "../pages/Minigrid/SingleMinigrid/MinigridLiveEnergyDashboardPage/MinigridLiveEnergyDashboardPage";
import SingleMinigridUpdatePage from "../pages/Minigrid/SingleMinigrid/SingleMinigridUpdatePage/SingleMinigridUpdatePage";
import CreatePlanBTPage from "../pages/PlanBT/CreatePlanBTPage/CreatePlanBTPage";
import EditPlanBTPage from "../pages/PlanBT/EditPlanBTPage/EditPlanBTPage";
import PlanBTListPage from "../pages/PlanBT/PlanBTListPage/PlanListBTPage";
import SinglePlanBTPage from "../pages/PlanBT/SinglePlanBTPage/SinglePlanBTPage";
import SettingsPage from "../pages/SettingsPage/SettingsPage";
import MomiPage from "../pages/SettingsPage/MomiPage/MomiPage";
import LuminairePage from "../pages/SettingsPage/LuminairePage/LuminairePage";
// import ClientListPage from "../pages/SuivisClientPage/ClientListPage/ClientListPage";
import ClientV2Page from "../pages/ClientV2Page/ClientV2Page";
import ClientListPage from "../pages/ClientPage/ClientListPage/ClientListPage";
import ListInfraPage from "../pages/SuivisInfra/ListInfraPage/ListInfraPage";
import LuminaireListPage from "../pages/Luminaire/LuminaireListPage/LuminaireListPage";
import LuminaireDashboardPage from "../pages/Luminaire/LuminaireDashboardPage/LuminaireDashboardPage";
import FleetListPage from "../pages/Fleet/FleetListPage/FleetListPage";
import FleetDetailPage from "../pages/Fleet/FleetDetailPage/FleetDetailPage";
import RoleManagementPage from "../pages/SettingsPage/RoleManagementPage/RoleManagementPage";
import { RequireCapability } from "../features/rbac";

// RBAC : les pages d'écriture sont gardées par capacité (le backend renvoie de
// toute façon 403). Les pages de lecture restent accessibles à tout rôle.

export const mainPageRoutes = [
    {
        path: "/plan-bt",
        name: "Pan BT",
        main: () =>  <PlanBTListPage/>  
    },

    {
        path: "/plan-bt/:planBTId",
        name: "Plan BT",
        main: () =>  <SinglePlanBTPage />
    },

    {
        path: "/plan-bt/create",
        name: "Plan BT",
        main: () =>  <RequireCapability capability="planbt.edit"><CreatePlanBTPage /></RequireCapability>
    },
    {
        path: "/plan-bt/:planBTId/edit",
        name: "Plan BT",
        main: () =>  <RequireCapability capability="planbt.edit"><EditPlanBTPage/></RequireCapability>
    },
    {
        path: "/",
        name: "Home",
        main: () => <HomePage/>
    },
    {
        path: "/minigrid",
        name: "minigrid",
        main: () => <MinigridListPage />
    },

    {
        path: "/minigrid/create",
        name: "minigrid",
        main: () => <RequireCapability capability="equipment.edit"><CreateMinigridPage/></RequireCapability>
    },
    {
        path: "/minigrid/:minigridId/live/:energySegment",
        name: "minigrid-live-energy",
        main: () => <MinigridLiveEnergyDashboardPage />
    },
    {
        path: "/minigrid/:minigridId",
        name: "minigrid",
        main: () => <SingleMinigridPage />
    },
    {
        path: "/minigrid/:minigridId/edit",
        name: "minigrid",
        main: () => <RequireCapability capability="equipment.edit"><SingleMinigridUpdatePage/></RequireCapability>

    },

    {
        path: "/meters",
        name: "client",
        main: () => <ClientListPage />
    },

    {
        path: "/meters/:deviceId",
        name: "client-v2",
        main: () => <ClientV2Page />
    },

    {
        path: "/dashboard",
        name: "Dashboard",
        main: () => <DashboardListPage />
    },

    {
        path: "/dashboards",
        name: "Dashboards",
        main: () => <DashboardHubPage />
    },

    {
        path: "/dashboards/default",
        name: "Dashboard Default",
        main: () => <DashboardDefaultPage />
    },

    {
        path: '/setting',
        name: 'Plan Setting',
        main: () => <SettingsPage/>
    },

    {
        path: '/setting/momi',
        name: 'Mes MoMis',
        main: () => <RequireCapability capability="equipment.edit"><MomiPage/></RequireCapability>
    },

    {
        path: '/setting/luminaires',
        name: 'Luminaires',
        main: () => <RequireCapability capability="equipment.edit"><LuminairePage/></RequireCapability>
    },

    {
        path: '/setting/roles',
        name: 'Rôles & accès',
        main: () => <RoleManagementPage/>
    },

    {
        path: '/infra',
        name: 'Suivis Infra',
        main: () => <ListInfraPage/>
    },
    {
        path: '/luminaires',
        name: 'Luminaires',
        main: () => <LuminaireListPage/>
    },

    {
        path: '/luminaires/:devEui',
        name: 'Luminaire Dashboard',
        main: () => <LuminaireDashboardPage/>
    },

    {
        path: '/setting/fleets',
        name: 'Fleets',
        main: () => <FleetListPage/>
    },

    {
        path: '/setting/fleets/:fleetId',
        name: 'Fleet Detail',
        main: () => <FleetDetailPage/>
    },

    {
        path: '/extract',
        name: 'Extract',
        main: () => <ExtractPage/>
    },
    {
            path: '/plan-bt-v2/:planBTId',
            name: 'Plan BT V2',
            main: () => <GridEditor/>
    }

]

export default mainPageRoutes
